export default {
    emailAddress: '',
    isLoading: false,
    status: 'initial',
    errorMessage: '',
    isSent: false
}
